'use client';

import { useAuth } from '@/contexts/AuthContext';

/**
 * useKlaviyo — thin hook for firing Klaviyo events from client components.
 *
 * Events are proxied through /api/klaviyo/track so the private API key is
 * never exposed in the browser bundle.
 *
 * Usage:
 *   const { track } = useKlaviyo();
 *   track('Viewed Competition', { competitionId, title });
 */
export function useKlaviyo() {
  const { user, userProfile } = useAuth();

  const track = async (eventName, properties = {}) => {
    try {
      const profile = {
        email: userProfile?.email ?? user?.email ?? null,
        external_id: user?.id ?? null,
        first_name: userProfile?.first_name ?? null,
        last_name: userProfile?.last_name ?? null,
      };

      await fetch('/api/klaviyo/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event: eventName, properties, profile }),
      });
    } catch (err) {
      // Never let tracking errors surface to the user
      console.error('[useKlaviyo] track error:', err);
    }
  };

  return { track };
}
